// extracted by mini-css-extract-plugin
module.exports = {"header":"LightBoxHeader_header__JkUNi","button":"LightBoxHeader_button___Pg_V","hideOnMobile":"LightBoxHeader_hideOnMobile__w7MqE"};